import styled from 'styled-components'
import {
  BUTTON_FILL_COLORS,
  ROUND_BUTTON_HOVER_COLORS,
  ROUND_BUTTON_SIZING,
  ROUND_ICON_COLORS
} from './constants'

const getBorder = (props) => `${props.borderWidth ? props.borderWidth : 1}px solid`
  + `${props.borderColor ? props.borderColor : props.theme.color.background}`

export const RoundButtonStyle = styled.button`
  position: relative;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  height: ${props =>
    props.diameter ||
    ROUND_BUTTON_SIZING[props.size] ||
    ROUND_BUTTON_SIZING.s}px;
  width: ${props =>
    props.diameter ||
    ROUND_BUTTON_SIZING[props.size] ||
    ROUND_BUTTON_SIZING.s}px;
  border-radius: 50%;
  background-color: ${props =>
    props.backgroundColor
      ? props.theme.color[props.backgroundColor]
      : props.mood
        ? props.mood === 'disabled'
          ? props.theme.color.backgroundRush
          : props.theme.color[BUTTON_FILL_COLORS[props.mood]]
        : props.theme.color.backgroundRush};
  box-shadow: ${props =>
    props.borderWidth
      ? 'none'
      : props.theme.shadow.s};
  border: ${props =>
    props.mood === 'disabled' || props.borderWidth
      ? getBorder(props)
      : 'none'};
  pointer-events: ${props => (props.mood === 'disabled' ? 'none' : 'auto')};
  transition: all ${p => p.theme.duration.s} ${p => p.theme.function.oq};

  svg {
    transition: all ${p => p.theme.duration.s} ease-out;
    height: ${props => (props.iconHeight ? props.iconHeight : 20)}px;
    fill: ${props =>
    props.iconColor
      ? props.theme.color[props.iconColor]
      : props.theme.color[ROUND_ICON_COLORS[props.mood]] || 'white'};
  }

  &:hover {
    transform: ${props =>
    props.borderWidth
      ? 'none'
      : `translateY(-1px)`};
    box-shadow: ${props =>
    props.borderWidth
      ? 'none'
      : props.theme.shadow.m};
    border-color: ${props =>
    props.borderWidth
      ? props.theme.color.turquoiseNight
      : 'none'};
    background-color: ${props =>
    props.borderWidth
      ? props.theme.color.turquoiseNight
      : props.backgroundColor
        ? props.theme.color[props.backgroundColor]
        : props.mood
          ? props.mood === 'disabled'
            ? props.theme.color.backgroundRush
            : props.theme.color[BUTTON_FILL_COLORS[props.mood]]
          : props.theme.color.backgroundRush};

    svg {
      fill: ${props =>
    props.iconColor
      ? props.theme.color[props.iconColor]
      : props.borderWidth
        ? props.theme.color.mainFont
        : props.theme.color[ROUND_BUTTON_HOVER_COLORS[props.mood]]};
    }
  }

  &:active {
    box-shadow: ${props =>
    props.borderWidth
      ? 'none'
      : props.theme.shadow.m};
    transform: ${props =>
    props.borderWidth
      ? 'none'
      : 'scale(0.95) translateY(2px)'};
  }
`;
